import { tv } from '@change/ds-utils';

export const container = tv({
	base: 'bg-fill-accent-primary-weaker flex flex-col gap-6 rounded-2xl p-6',
});

export const endorserInfo = tv({
	base: 'flex items-center gap-4',
});

export const avatarContainer = tv({
	base: 'relative inline-grid grid-cols-1 grid-rows-1 items-start justify-items-start',
});

export const avatarImage = tv({
	base: 'border-stroke-weaker bg-fill-weaker col-start-1 row-start-1 h-[54px] w-[54px] rounded-full border-4 object-cover',
});

export const avatarPlaceholder = tv({
	base: 'border-stroke-weaker bg-fill-weaker col-start-1 row-start-1 flex h-[54px] w-[54px] items-center justify-center rounded-full border-4',
});

export const endorserDetails = tv({
	base: 'flex flex-col items-start justify-center gap-0.5',
});

export const endorserTitleRow = tv({
	base: 'flex items-center gap-1.5',
});

export const divider = tv({
	base: 'border-stroke-accent-primary-weak h-0 w-full border-t',
});

export const endorsementTextContainer = tv({
	base: 'flex flex-col items-start gap-2',
});

export const endorsementText = tv({
	base: 'text-typography-disabled font-serif whitespace-pre-line italic',
});
